import type { PluginCatalogueItem } from '@/shared/api/types/plugins';
import { Button } from '@/shared/components';
import { PluginConnectionKeyCard } from './PluginConnectionKeyCard';
import { PluginSyncStatus } from './PluginSyncStatus';
export function PluginConnectionTab({
  plugin,
  onAction,
}: {
  plugin: PluginCatalogueItem;
  onAction: (action: 'disable' | 'revoke') => void;
}) {
  const state = plugin.installation?.state;
  const installed = plugin.installation && state !== 'Revoked';
  return (
    <div className="space-y-6">
      {plugin.canManage && plugin.installation && (
        <PluginSyncStatus
          installationId={plugin.installation.id}
          installationState={plugin.installation.state}
          grantRevision={plugin.installation.grantRevision}
        />
      )}
      <section>
        <h2 className="font-serif text-xl">
          {plugin.installation?.externalWorkspaceName ?? 'Workspace verbinden'}
        </h2>
        <p className="text-ink-soft mt-2">
          {state === 'Active'
            ? 'Die Verbindung ist eingerichtet. Berechtigte Gespräche stehen in GuestAI zur Verfügung, sobald der Abgleich abgeschlossen ist.'
            : state === 'Disabled'
              ? 'Der Zugriff ist gesperrt. Aktivieren Sie das Plugin erneut, um fortzufahren.'
              : state === 'Revoked'
                ? 'Der Zugriff wurde endgültig entzogen. Die Löschung dieser Installation wurde angefordert.'
                : 'Melden Sie sich in GuestAI an und bestätigen Sie anschließend beide Workspaces.'}
        </p>
        {installed && state !== 'Disabled' && plugin.applicationUrl && (
          <Button asChild size="lg" variant="primary" className="mt-4">
            <a href={plugin.applicationUrl}>Zu GuestAI</a>
          </Button>
        )}
        {!plugin.applicationUrl && (
          <p className="text-ink-soft mt-4 text-sm">
            Die Verbindung wurde noch nicht vom Betreiber konfiguriert.
          </p>
        )}
      </section>
      {plugin.canManage && <PluginConnectionKeyCard pluginId={plugin.id} />}
      {plugin.canManage && installed && (
        <section className="border-line space-y-3 border-t pt-5">
          <h2 className="font-serif text-xl">Zugriff beenden</h2>
          <p className="text-ink-soft text-sm">
            Sperrt auch gespeicherte Ansichten für alle Teammitglieder.
          </p>
          <div className="flex flex-wrap gap-3">
            {state !== 'Disabled' && (
              <Button type="button" size="lg" onClick={() => onAction('disable')}>
                Deaktivieren
              </Button>
            )}
            <Button
              type="button"
              size="lg"
              variant="destructive"
              onClick={() => onAction('revoke')}
            >
              Endgültig entziehen
            </Button>
          </div>
        </section>
      )}
    </div>
  );
}
